import type { TOptional } from '@/types/common';

const delay = <V>(timeout: number, value?: V): Promise<TOptional<V>> =>
  new Promise((resolve) => {
    setTimeout(() => resolve(value), timeout);
  });

export default delay;
